// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"6bc56459","236":"b4971c86","370":"5d5e725e","407":"7722dba7","574":"0d333095","798":"764bda54","848":"903a2ea6","923":"5db300c5"}[chunkId] + ".chunk.js";
};